import { render, staticRenderFns } from "./newKeyWordStatisticsDetailChatContent.vue?vue&type=template&id=21a4ca10&scoped=true&"
import script from "./newKeyWordStatisticsDetailChatContent.vue?vue&type=script&lang=js&"
export * from "./newKeyWordStatisticsDetailChatContent.vue?vue&type=script&lang=js&"
import style0 from "./newKeyWordStatisticsDetailChatContent.vue?vue&type=style&index=0&id=21a4ca10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a4ca10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a4ca10')) {
      api.createRecord('21a4ca10', component.options)
    } else {
      api.reload('21a4ca10', component.options)
    }
    module.hot.accept("./newKeyWordStatisticsDetailChatContent.vue?vue&type=template&id=21a4ca10&scoped=true&", function () {
      api.rerender('21a4ca10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/newKeyWordStatisticsDetailChatContent.vue"
export default component.exports